export enum SearchTypes {
  Sort = 'sort',
  PerPage = 'perPage',
  Page = 'page',
  Query = 'query',
}
